import React, { useImperativeHandle } from "react";
import { Range, getTrackBackground } from "react-range";
import { toMoney } from "../../../Components/Functions";

const STEP = 500;
const MIN = 0;
const MAX = 20000;
// const DEFAULT = [2500, 12500];
const DEFAULT = [MIN, MAX];

const RateRanger =  React.forwardRef(({ rtl }, ref) => {
	const [values, setValues] = React.useState(DEFAULT);

    useImperativeHandle(ref, () => ({
        reset: () => reset(),
        getValues: () => {
            return values
        }
      }));

    const reset = () => setValues(DEFAULT);
    

	return (
		<>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: 10,
				}}
			>
				<h6 style={{ fontWeight: 600, margin: 0 }}>Rate</h6>
				<button onClick={reset} className="clear-button">
					Reset
				</button>
			</div>

			<Range
				values={values}
				step={STEP}
				min={MIN}
				max={MAX}
				rtl={rtl}
				onChange={(values) => {
					setValues(values);
				}}
				renderTrack={({ props, children }) => (
					<div
						onMouseDown={props.onMouseDown}
						onTouchStart={props.onTouchStart}
						style={{
							...props.style,
							height: "35px",
							display: "flex",
							width: "100%",
						}}
					>
						<div
							ref={props.ref}
							style={{
								height: "5px",
								width: "100%",
								borderRadius: "4px",
								background: getTrackBackground({
									values,
									colors: ["#ccc", "#37514b", "#ccc"],
									min: MIN,
									max: MAX,
									rtl,
								}),
								alignSelf: "center",
							}}
						>
							{children}
						</div>
					</div>
				)}
				renderThumb={({ props, isDragged }) => (
					<div
						{...props}
						style={{
							...props.style,
							height: "35px",
							paddingRight: 5,
							paddingLeft: 5,
							borderRadius: "4px",
							backgroundColor: "#FFF",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							boxShadow: "0px 2px 6px #AAA",
						}}
					>
						<label style={{ fontSize: 10 }}>
							{toMoney(props["aria-valuenow"], null, 0)}
						</label>
					</div>
				)}
			/>
		</>
	);
});



export default RateRanger;

